import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsersCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 18.0039L18 20.0039L22 16.0039M12 15.0039H8C6.13623 15.0039 5.20435 15.0039 4.46927 15.3084C3.48915 15.7144 2.71046 16.4931 2.30448 17.4732C2 18.2083 2 19.1401 2 21.0039M15.5 3.29466C16.9659 3.88805 18 5.32522 18 7.00391C18 8.6826 16.9659 10.1198 15.5 10.7131M13.5 7.00391C13.5 9.21305 11.7091 11.0039 9.5 11.0039C7.29086 11.0039 5.5 9.21305 5.5 7.00391C5.5 4.79477 7.29086 3.00391 9.5 3.00391C11.7091 3.00391 13.5 4.79477 13.5 7.00391Z",
		stroke: "#626F86",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUsersCheck;
